import { StyledLabel, StyledModal } from "@aureskonnect/react-ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { capitalize } from "@helpers/general";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";

type ModalConfirmationCopyType = {
    isModalOpened: boolean;
    setIsModalOpened: Function;
    validation: Function;
    message: string;
};
export function ModalConfirmationCopy({
    isModalOpened,
    setIsModalOpened,
    validation,
    message,
}: ModalConfirmationCopyType) {
    const { t } = useTranslation();

    return (
        <StyledModal
            toggle={() => setIsModalOpened(false)}
            isOpen={isModalOpened!}
            centered
        >
            <ModalHeader
                className="text-capitalize"
                toggle={() => setIsModalOpened(false)}
            >
                <span>{capitalize(t("Alert"))}</span>
            </ModalHeader>
            <ModalBody>
                <StyledLabel
                    className="pl-3 m-0"
                    style={{ whiteSpace: "pre-line" }}
                >
                    {message}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        setIsModalOpened(false);
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        validation();
                        setIsModalOpened(false);
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
